import Logo from './Logo';
import { HiMail, HiPhone } from 'react-icons/hi';

const navItems = [
  { href: "/about", label: "About" },
  { href: "/careers", label: "Careers" },
  { href: "/news", label: "News" }
];

const WaveDivider = () => (
  <div className="wave-divider light-mode">
    <svg viewBox="0 0 1440 170" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0,85L240,96.3C480,108,960,130,1440,130.3L1440,170L0,170Z" />
    </svg>
  </div>
);

const CallToAction = () => (
  <section className="py-20 light-mode" id="cta">
    <div className="container mx-auto px-6 relative">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-4xl font-bold mb-6">Ready to Takeoff? 🚀</h2>
        <p className="text-xl mb-8">
          Join our community of jobseekers who are leaving lasting impressions standing out with professional portfolios. Pilot your path to success with Takeoff.<br /><br />
          Start your 30-day free trial today.
        </p>
        <div className="flex flex-col sm:flex-row justify-center items-center">
          <a href="http://editor.readyfortakeoff.app/sign-up" className="btn-primary text-lg px-8 py-4 mb-4 sm:mb-0 sm:mr-4">
            GET STARTED <span className="ml-2" style={{color: "white"}}>→</span>
          </a>
          <p className="text-sm opacity-75">
            No credit card required • Free for 30 days
          </p>
        </div>
      </div>
    </div>
  </section>
);

const FooterNav = () => (
  <nav className="flex flex-col mt-6 text-sm">
    {navItems.map((item, index) => (
      <a key={index} href={item.href}>
        {item.label}
      </a>
    ))}
  </nav>
);

export default function Footer() {
  return (
    <>
      <WaveDivider />
      <CallToAction />

      <footer className="py-12 light-mode">
        <div className="container mx-auto px-6 relative">
          <div className="mb-4">
            <Logo icon color="var(--accent-color)" />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-12">
            <div>
              <p>
                Professional portfolio builder for jobseekers. Stand out from the crowd and land your dream job.
              </p>
              {/* <FooterNav /> */}
            </div>
            
            <div className="text-md-right">
              <ul className="space-y-2">
                <li className="flex items-center justify-start md:justify-end">
                  <HiMail className="h-5 w-5 mr-2" />
                  <a href="mailto:info@takeoff.careers">info@takeoff.careers</a>
                </li>
                <li className="flex items-center justify-start md:justify-end">
                  <HiPhone className="h-5 w-5 mr-2" />
                  <a href="tel:+12362340244">+1 (236) 234-0244</a>
                </li>
              </ul>
            </div>
          </div>      
          
          <div className="border-t border-gray-700 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <div className="mb-4 md:mb-0">
                <p className="text-sm opacity-75">
                © 2025 Takeoff Software Inc. All rights reserved. Made with ❤️ for jobseekers everywhere.
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}